import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AllTaxonomyItemsState, TaxonomyItem } from './types'

const initialState: AllTaxonomyItemsState = {
  list: [],
  byNetwork: {},
  loading: false,
  error: undefined,
}

const allTaxonomyItemsSlice = createSlice({
  name: 'allTaxonomyItems',
  initialState,
  reducers: {
    setAllTaxonomyItems(state, action: PayloadAction<TaxonomyItem[]>) {
      state.list = action.payload
      state.loading = false
    },
    setAllTaxonomyItemsLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload
    },
    setAllTaxonomyItemsByNetwork(
      state,
      action: PayloadAction<Record<string, TaxonomyItem[]>>,
    ) {
      state.byNetwork = action.payload
    },
    setAllTaxonomyItemsError(state, action: PayloadAction<string>) {
      state.error = action.payload
      state.loading = false
    },
  },
})

export default allTaxonomyItemsSlice.reducer

export const {
  setAllTaxonomyItems,
  setAllTaxonomyItemsError,
  setAllTaxonomyItemsLoading,
  setAllTaxonomyItemsByNetwork,
} = allTaxonomyItemsSlice.actions
